import { render, staticRenderFns } from "./CompanyAboutUs.vue?vue&type=template&id=8095710e"
import script from "./CompanyAboutUs.vue?vue&type=script&lang=js"
export * from "./CompanyAboutUs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports